import { Chip } from "shared/UI/Chip/Chip";
import { ClickableRoundedCard } from "../../../Support/Components/ContactCard/ClickableRoundedCard";
import { JournalAttribute } from "shared/request/myHealthyAdvantageApi";
import { parseDateToString } from "core/helpers/dates";
import classNames from "classnames";

type EntrySummaryCardProps = {
  onClick: () => void;
  attributes?: JournalAttribute[];
  date: string;
  content: string;
  className?: string;
};

export const EntrySummaryCard = ({ date, content, attributes, onClick, className }: EntrySummaryCardProps) => {
  const formattedDate = parseDateToString(new Date(date));
  return (
    <ClickableRoundedCard title={formattedDate} className={classNames("!bg-brand-green-lighter", className)} handleClick={onClick}>
      <div className="flex flex-col space-between">
        <p className="whitespace-pre-line line-clamp-2">{content}</p>
        <div className="relative overflow-x-hidden">
          <div className="flex gap-2 pt-5">
            {attributes && attributes.map((attribute: JournalAttribute) => <Chip key={attribute.id} text={attribute.key} theme="secondary" />)}
          </div>
          <div className="right-0 top-0 absolute w-1/2 h-full bg-gradient-to-r from-transparent to-brand-green-lighter"></div>
        </div>
      </div>
    </ClickableRoundedCard>
  );
};
